import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { TipoMultaService } from '../services/tipo-multa.service';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-tipos-multa-edit',
	templateUrl: './tipos-multa-edit.component.html',
	styleUrls: ['./tipos-multa-edit.component.css'],
	animations: [loadingFade]
})
export class TiposMultaEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public tipo_multa_id = null;

	public formTipoMulta: FormGroup;
	public natureza_array = [
		{ natureza_label: 'Leve' }, { natureza_label: 'Média' }, { natureza_label: 'Grave' }, { natureza_label: 'Gravíssima' }
	]

	constructor(private route: ActivatedRoute,
				private fb: FormBuilder,
				private router: Router,
				private tipoMultaSvc: TipoMultaService) { }

	ngOnInit() {
		this.criaForm();

		this.loading = true;

		this.route.params.subscribe( params => {
			if (params.id) {
				this.tipo_multa_id = params.id;
				// pega dados a partir do id
				this.tipoMultaSvc.getTipoMulta(params.id).then((data: any) => {
					this.preencheForm({
						tipo_multa_id: data.tipo_multa_id,
						tipo_multa_nome: data.tipo_multa_nome,
						tipo_multa_descricao: data.tipo_multa_descricao,
						tipo_multa_pontuacao: data.tipo_multa_pontuacao,
						tipo_multa_natureza: data.tipo_multa_natureza,
						tipo_multa_valor: data.tipo_multa_valor
					});

					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formTipoMulta = this.fb.group({
			tipo_multa_id: null,
			tipo_multa_nome: ['', Validators.required],
			tipo_multa_descricao: '',
			tipo_multa_pontuacao: ['', Validators.required],
			tipo_multa_natureza: [null, Validators.required],
			tipo_multa_valor: ['', Validators.required]
		});
	}

	preencheForm(dados) {
		this.formTipoMulta.setValue(dados);
	}

	enviaTipoMulta() {
		if (this.formTipoMulta.valid) {
			this.submitting = true;

			let toSend = this.formTipoMulta.value;

			if (this.tipo_multa_id === null) { // criar
				this.tipoMultaSvc.criaTipoMulta(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Tipo de multa cadastrado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/tiposmulta']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.tipoMultaSvc.editaTipoMulta(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Tipo de multa alterado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/tiposmulta']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for( let field in this.formTipoMulta.controls){
				let campo = this.formTipoMulta.get(field);
				campo.markAsTouched();
			}
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formTipoMulta.get(nome);
		return input.touched && input.invalid;
	}
}
